export function imgixParam(imageUrl, params = {}) {
  if (typeof URL === 'undefined') {
    return imageUrl;
  }

  const urlInstance = new URL(imageUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      urlInstance.searchParams.delete(key);
    } else {
      urlInstance.searchParams.set(key, value);
    }
  });
  return urlInstance.toString();
}

/**
 * Generates static asset url including ASSET_PREFIX if exists
 * @param {String} staticAssetPath
 */
export function staticAssetUrl(staticAssetPath) {
  return `${process.env.ASSET_PREFIX}${staticAssetPath}`;
}

export function transformImageUrl(
  imageData,
  { width: targetWidth, height: targetHeight, resolution = 1, format: imageFormat } = {}
) {
  const imageSrc = new URL(imageData.url);
  const { width: originalWidth, height: originalHeight } = imageData;
  const imageExtensionMatch = imageSrc.pathname.match(/\.(?<extension>\w{3,4})$/i);

  let imageExtension = null;
  if (imageExtensionMatch) {
    imageExtension = imageExtensionMatch.groups.extension.toLocaleLowerCase();
  }

  let imageProps = {
    src: imageSrc.toString(),
    width: originalWidth,
    height: originalHeight,
  };

  // Process custom parameters only if SVG
  // Prevents next.js image handling from breaking when receiving a contentful SVG image url with
  // Size and format parameters
  if (imageExtension !== 'svg') {
    if (imageFormat) {
      // https://www.contentful.com/developers/docs/references/images-api/#/reference/changing-formats/image-format
      imageSrc.searchParams.set('fm', imageFormat);
      imageProps.url = imageSrc.toString();
    }

    // Handle fixed size output
    if (targetWidth && targetHeight) {
      imageSrc.searchParams.set('w', targetWidth * resolution);
      imageSrc.searchParams.set('h', targetHeight * resolution);
      imageSrc.searchParams.set('fit', 'fill');
      imageProps = {
        url: imageSrc.toString(),
        width: targetWidth,
        height: targetHeight,
      };
    }
    // Only set width, adjust height proportionally
    else if (targetWidth) {
      imageSrc.searchParams.set('w', targetWidth * resolution);
      imageProps = {
        url: imageSrc.toString(),
        width: targetWidth,
        height: (targetWidth * originalHeight) / originalWidth,
      };
    }
    // Only set height, adjust width proportionally
    else if (targetHeight) {
      imageSrc.searchParams.set('h', targetHeight * resolution);
      imageProps = {
        url: imageSrc.toString(),
        width: (targetHeight * originalWidth) / originalHeight,
        height: targetHeight,
      };
    }
  }

  return {
    ...imageData,
    ...imageProps,
  };
}
